(function ($, ep) {
    "use strict";

    /*
    Remove current errors messages and highlighting (reset to state like form is shown first time
                                                and validation is not triggered until submit)
     */

    $.fn.clearValidationErrors = function(){
        return this.each(function(){
            var validator = $(this).validate();
            validator.submitted = {};
            validator.prepareForm();
            validator.hideErrors();
            validator.elements().removeClass(validator.settings.errorClass);
        });
    };

    /*
    Date validation rules
     */

    var validationHelper = {
        isValidDate: function(element, value){
            try {
                this.parseDate(element, value);
            }catch(e){
                return false;
            }

            return true;
        },

        isBetweenMinAndMax: function(element, value){
            var date = this.parseDate(element, value);
            var minDate = $(element).datepicker('option', 'minDate') ||  ep.defaultMinDate;
            var maxDate = $(element).datepicker('option', 'maxDate') || ep.defaultMaxDate;

            return !date || (date >= minDate) && (date <= maxDate);
        },

        parseDate: function(element, value){
            var inst = $.datepicker._getInst(element);
            var dateFormat = $.datepicker._get(inst, 'dateFormat');
            return $.datepicker.parseDate(dateFormat, value, $.datepicker._getFormatConfig(inst));
        },

        addValidationRule: function(name, validationFunction) {
            $.validator.addMethod(name, validationFunction,
                function (/* params */) {
                    return 'Invalid date';
                });

            var classRules = {};
            classRules[name] = true;

            $.validator.addClassRules(name, classRules);
        }
    };

    // Numeric input range validator.
    validationHelper.addValidationRule('range', function (value, element, param) {
        var separator = $(element).data("decimal-separator") || ep.currentCultureSettings.decimalSeparator;
        var globalizedValue = value.replace(separator, ".");
        return this.optional(element) || (globalizedValue >= param[0] && globalizedValue <= param[1]);
    });

    // Dates validation.
    validationHelper.addValidationRule('jQueryDate', function (value, element ) {
        if (!validationHelper.isValidDate(element, value)){
            return false;
        }

        var date = validationHelper.parseDate(element, value);

        return this.optional(element) || !date ||
            (validationHelper.isBetweenMinAndMax(element, value));
    });

    validationHelper.addValidationRule('jQueryValidDate', function(value, element){
        return validationHelper.isValidDate(element, value);
    });

    validationHelper.addValidationRule('jQueryMinMaxDates', function(value, element){
        return validationHelper.isValidDate(element, value) && validationHelper.isBetweenMinAndMax(element, value);
    });

    $.fn.setDefaultMaxDate = function(){
        this.datepicker("option", 'maxDate', ep.defaultMaxDate);
        return this;
    };

    $.fn.setDefaultMinDate = function(){
        this.datepicker("option", 'minDate', ep.defaultMinDate);
        return this;
    };

    /*
    moneyPresenter validation rules
     */

    $.validator.addMethod('moneyPresenterPositiveNumber', function(value, element){
            //not null or 0.
            return !!($(element).moneyPresenter('getValue'));
        },
        function (/* params */) { return 'must be positive number'; }
    );

    $.validator.addMethod('integer', function(value){
            if(!value)
                return true;

            return (/^(-){0,1}\d+$/).test(value);
        },
        function (/* params */) { return 'must be integer'; }
    );
})(jQuery, ep);
